import * as ActionTypes from 'state/actions/types'
import Session from 'shared/utils/session'

const initialState = {
  active: {
    agentId: 'default'
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.INIT_DATA: {
      const {
        agentId,
        activeOrg
      } = action.payload

      Session.setItem(`agentId_${activeOrg.organisationId}`, agentId)

      return {
        ...state,
        active: {
          agentId
        }
      }
    }
    case ActionTypes.SELECT_AGENT: {
      const {
        agent,
        organisation
      } = action.payload

      Session.setItem(`agentId_${organisation.organisationId}`, agent.agentId)

      return {
        ...state,
        active: agent
      }
    }

    case ActionTypes.ACTIVATE_ORGANISATION: {
      if(!action?.payload?.organisation) return state

      const {
        organisation
      } = action.payload

      const agentId = Session.getItem(`agentId_${organisation.organisationId}`),
            hasAgents = organisation.projects && !!organisation.projects.length,
            environments = organisation.environments || []


      let activeAgent = null
      if(hasAgents && agentId) {
        activeAgent = organisation.projects.find(agent => agent.agentId === agentId)
      }

      if(!activeAgent) activeAgent = organisation.projects[0]

      if(activeAgent.projectId){
        //this is versions agent, make sure it's PROD agent
        let prodAgent = null
        const prodEnv = environments.find(e => e.projectId === activeAgent.projectId && e.type === 'PROD')
        if(prodEnv) prodAgent = organisation.projects.find(agent => agent.agentId === prodEnv.agentId)
        if(prodAgent) activeAgent = prodAgent
      }

      if(activeAgent && activeAgent.agentId) {
        Session.setItem(`agentId_${organisation.organisationId}`, activeAgent.agentId)
      }

      return {
        ...state,
        active: activeAgent
      }
    }

    case ActionTypes.ON_NAVIGATE: {
      const { route } = action.payload
      if(!route) return state

      switch(route) {
        case 'chatapp': {
          window.location.href = `${window.location.origin}/${route}`
          break
        }

        default: {
          window.location.href = `${window.location.origin}/${state.active.agentId}/${route}`
          break
        }
      }

      return state
    }

    default:
      return state
  }
}
